<template>
  <div class="back" :style="'background-image: url(' + imgPath + ');'">
    <div v-if="show">
      <img src="../../../../assets/newImage/zoodian_logo3.png" class="back_logo">
      <div class="back_desc">
        <p style="font-weight:bold;" :style="'font-size:' + titleSize + 'px;'">{{ $t("register.title") }}</p>
        <div class="back_desc_box" :style="'margin-top:' + descMargin + 'px;'" v-for="(item, index) in descList"
          :key="index">
          <div>
            <img src="../../../../assets/newImage/gou.png"
              style="width:20px;height: 17px;margin-top:3px;object-fit:cover;">
          </div>
          <div>
            <p style="font-size: 18px;font-weight: bold;margin-bottom: 5px;">{{ item.title }}</p>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      titleSize: localStorage.getItem('lang') == 'en' ? 20 : 24,
      descMargin: localStorage.getItem('lang') == 'en' ? 30 : 40,
      descList: [{
        title: this.$t("register.many_hotel"),
        desc: this.$t("register.many_hotel_desc")
      }, {
        title: this.$t("register.best_sel"),
        desc: this.$t("register.best_sel_desc")
      }, {
        title: this.$t("register.service_guarantee"),
        desc: this.$t("register.service_guarantee_desc")
      }]
    }
  },
  props: {
    show: {
      show: Boolean,
      default: true
    },
    imgPath: {
      imgType: String,
      default: require('../../../../assets/newImage/bg_2.jpg')
    }
  }
}
</script>

<style lang="less" scoped>
.back {
  width: 100%;
  height: 100%;
  background-size: cover;
  object-position: right;
  position: relative;

  .back_logo {
    width: 63px;
    height: 31px;
    margin: 20px 20px;
  }

  .back_desc {
    position: absolute;
    left: 26%;
    top: 12%;
    width: 72%;
    color: #fff;
    line-height: initial;
    font-size: 12px;

    .back_desc_box {
      display: grid;
      grid-template-columns: 40px 1fr;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/login/components/RegisterAndLoginBackImage.vue